import React from 'react'
import { useNavigate } from 'react-router-dom';

const NotSureSection = ({ data }) => {
  const navigate = useNavigate();

  return (
    <section className="w-full px-4 sm:px-6 ava-section-gap  ">
      <div className="max-w-5xl mx-auto  bg-white  px-4 sm:px-6">

        <div className="flex flex-col sm:flex-row items-center gap-6 md:gap-10">

          {/* Image */}
          {/* <div className="w-full md:w-1/2"> */}
          <div className="w-full md:w-[40%] lg:w-1/2">
            <div className="w-full aspect-[4/3] md:h-[260px] overflow-hidden ava-radius-md ava-card-image ">
              <img
                src={data.image}
                alt={data.title}
                className="w-full h-full object-cover transition-transform duration-300 "
              />
            </div>
          </div>

          {/* Content */}
          <div className="w-full md:w-1/2 flex flex-col justify-center gap-3 text-center md:text-left">

            {/* <h2 className="font-semibold primary-text text-lg sm:text-xl md:text-2xl leading-snug"> */}
            <h2 className="primary-text ava-heading-md">
              {data.title}
            </h2>

            {/* <p className="text-sm sm:text-base primary-text leading-relaxed max-w-md mx-auto md:mx-0"> */}
            <p className="ava-text-body primary-text max-w-md mx-auto md:mx-0">
              {data.description}
            </p>

            {data.cta?.primary && (
              <div className="mt-2">
                <a
                  // onClick={() => navigate(data.cta.primary.href)}
                   href={data.cta.primary.href}
                  // className="inline-flex items-center gap-2 rounded-md font-semibold bg-[var(--primary-color)] text-white px-5 py-2 text-sm sm:text-base transition-all duration-200 hover:opacity-90 active:scale-95"
                  className='btn-primary'
                >
                  {data.cta.primary.label}
                  {/* <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                    <path d="M5 12h14M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
                  </svg> */}
                </a>
              </div>
            )}

          </div>
        </div>
      </div>
    </section>
  )
}

export default NotSureSection;